module.exports = __webpack_public_path__ + "media/images/icons/filled/file-word-fc6b8ff2d60025537edc4cd9a02e7f8a.svg";